import { render } from "./Draggable.vue?vue&type=template&id=481c9279"
import script from "./Draggable.vue?vue&type=script&lang=js"
export * from "./Draggable.vue?vue&type=script&lang=js"
script.render = render

export default script